export default __webpack_public_path__ + "static/media/heartTeal.932b16dd.svg";